/*
Cabinet Hinges
  --closeType <string::enum> | ['Soft', 'Free Swing', 'Self']
  --degreeOfOpen <float> | degrees
  --attachmentMethod <string::enum> | ['Insert', 'Screw', 'Press In']
  --overlay <string::enum> ['Inset', 'Full', 'Half']
  --loadWeight <float> | pounds
*/
import { loadWeight } from '@/modules/standardItems/schemas/baseFilters'
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Close Type',
    value: 'closeType',
    type: 'list',
    returnObject: false
  },
  {
    label: 'Degree of Open',
    value: 'degreeOfOpen',
    type: 'range'
  },
  {
    label: 'Attachment Method',
    value: 'attachmentMethod',
    type: 'list',
    returnObject: false
  },
  {
    label: 'Overlay',
    value: 'overlay',
    type: 'list',
    returnObject: false
  },
  loadWeight()
]
